import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {LtmsService} from '../../../../_services/ltms.service';
import {MaintenanceType, UpdateAccountModel} from '../../../../_models/ltms.model';
import {MessageService, PrimeNGConfig} from 'primeng/api';

interface Option {
    readonly name: string;
    readonly key: string;
}

@Component({
    selector: 'acabim-admin-edit-type',
    templateUrl: './edit-type.component.html',
    styleUrls: ['./edit-type.component.scss'],
    providers: [MessageService]
})
export class EditTypeComponent implements OnInit {
    @Output() updateResult = new EventEmitter<boolean>();
    _maintenanceType?: MaintenanceType;

    @Input()
    set typeDetails(value: MaintenanceType | undefined | null) {
        if (value) {
            this.actionType = 'Update';
            this._maintenanceType = value;
            this.initPage(value);
        } else {
            this.initPage();
        }
    }

    actionType = 'Add';
    isLoading = false;
    editTypeForm: any;
    valueTypes: any;
    accountTypes: any;
    terms: Option[] = [
        {name: 'Short', key: '1'},
        {name: 'Long', key: '0'},
    ];

    expenseType: Option[] = [
        {name: 'Opex', key: 'Opex'},
        {name: 'Capex', key: 'Capex'},
    ];

    categories: any;
    accounts: any;

    constructor(private readonly maintenanceService: LtmsService, private messageService: MessageService,
                private primengConfig: PrimeNGConfig) {
        this.editTypeForm = new FormGroup({
            name: new FormControl(null, Validators.required),
            description: new FormControl(null),
            category: new FormControl(null),
            account: new FormControl(null),
            term: new FormControl(null),
            priority: new FormControl(null)
        });
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.editTypeForm.get('term')?.valueChanges.subscribe((e: any) => {
            this.editTypeForm.get('term')?.setValue(e, {emitEvent: false});
        });
        this.editTypeForm.get('priority')?.valueChanges.subscribe((e: any) => {
            this.editTypeForm.get('priority')?.setValue(e, {emitEvent: false});
        });
    }

    initPage(type?: MaintenanceType): void {
        this.isLoading = true;
        this.maintenanceService.getAccounts().subscribe(account => {
            this.accounts = account.data;
            this.maintenanceService.getCategories().subscribe(category => {
                this.categories = [];
                category.data.forEach((d: any) => {
                    this.categories.push({name: d});
                });
                if (type) {
                    this.maintenanceService.getTypeDetails(type.id.toString()).subscribe(data => {
                        console.log(data);
                        this.editTypeForm.get('name').patchValue(data.name);
                        this.editTypeForm.get('description').patchValue(data.description);
                        // tslint:disable-next-line:no-shadowed-variable
                        const category = this.categories.filter((x: any) =>
                            x.name === data.category
                        )[0];
                        this.editTypeForm.get('category').patchValue(category);
                        // tslint:disable-next-line:no-shadowed-variable
                        const account = this.accounts.filter((x: any) =>
                            x.id === data.account?.id
                        )[0];
                        this.editTypeForm.get('account').patchValue(account);
                        this.editTypeForm.get('term').patchValue(data.term === '1');
                        this.editTypeForm.get('priority').patchValue(data.expense_type);

                        this.isLoading = false;
                    });
                } else {
                    this.isLoading = false;
                }
            });
        });
    }

    onSubmit(): void {
        const body: UpdateAccountModel = {
            name: this.editTypeForm.get('name')?.value,
            description: this.editTypeForm.get('description')?.value,
            category: this.editTypeForm.get('category')?.value?.name,
            term: this.editTypeForm.get('term')?.value === true ? '1' : '0',
            expense_type: this.editTypeForm.get('priority')?.value,
            account_id: this.editTypeForm.get('account')?.value?.id,
        };
        this.isLoading = true;
        if (this._maintenanceType) {
            this.maintenanceService.updateAccount(body, this._maintenanceType.id.toString()).subscribe(data => {
                this.editTypeForm.reset();
                this.updateResult.emit(true);
                this.isLoading = false;
            }, error => {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Cannot update maintenance type' + this._maintenanceType?.name
                });
                this.isLoading = false;
            });
        } else {
            this.maintenanceService.addAccount(body).subscribe(data => {
                this.editTypeForm.reset();
                this.updateResult.emit(true);
                this.isLoading = false;
            }, error => {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Cannot add this type'
                });
                this.isLoading = false;
            });
        }
    }
}
